import { jsx as a } from "react/jsx-runtime";
import e from "react";
import { B as o } from "../chunks/vendor_rango__assets.57b7cd48.js";
import i from "styled-components";
const s = i.div.withConfig({
  displayName: "Brand",
  componentId: "sc-93ragh-0"
})(["display:inline-flex;width:auto;height:var(--size-5x);svg{width:inherit;height:inherit;}"]), g = e.forwardRef(({
  brand: n = "AleloDefault",
  ...t
}, d) => {
  const r = o[n];
  return /* @__PURE__ */ a(s, { ...t, ref: d, "data-testid": "rango-brand", "data-rango-component": "rango-brand", "data-is-rango": !0, children: (() => r ? /* @__PURE__ */ a(r, { "data-testid": "rango-brand-svg" }) : null)() });
});
g.displayName = "RangoBrand";
export {
  g as RangoBrand
};
